<template>
  <div class="body-container">
    <div v-if="!msisdnSubmitted">
      <div class="flex-wrap text-center text-box p-2">
        <span
            class="text-content">Almost there! Please enter your mobile number below to subscribe to Zed Games at <strong>{{ this.currencyAmount[0] }}</strong>/{{ this.currencyAmount[1] }}.</span>
      </div>
      <div class="flex-wrap text-center text-box p-2 pt-1 msisdn-input-container">
        <input type="text" v-model="msisdn" v-on:change="msisdnConversion" class="text-content msisdn-input"
               placeholder="CELLPHONE NUMBER" required/>
      </div>
      <div class="flex-wrap text-center text-box" v-if="!validMsisdn">
        <span class="text-content error-message">Please enter a valid mobile number.</span>
      </div>
      <div class="d-flex justify-content-center p-1">
        <button class="retry-button mt-0" @click="onMsisdnSubmitClicked">SUBSCRIBE</button>
      </div>
    </div>

    <div v-if="msisdnSubmitted">
      <div class="d-flex col justify-content-center pt-1" v-if="(!errorMessage&&!subscribeError)">
        <img class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-6 header-image" src="../assets/images/thank-you-img.png">
      </div>
      <div class="flex-wrap text-center text-box p-3" v-if="!subscribeError">
        <span
            class="text-content">Thank you! Your request is being processed, please look out for a confirmation SMS.</span>
      </div>
      <div class="text-center error-message-text pt-2 flex-wrap" v-if="errorMessage">
        Please complete the sign up process and try again.
      </div>
      <div class="text-center error-message-text pt-2 flex-wrap" v-if="subscribeError">
        Error occurred please try again.
      </div>
      <div class="d-flex justify-content-center">
        <button @click="onRetryClicked"
                class="d-flex flex-row justify-content-center align-items-center continue-button" v-if="subscribeError">
          RETRY
        </button>
      </div>
    </div>
    <div class="d-flex flex-column flex-wrap text-center terms-and-conditions pt-3">
      <div>Subscription service.</div>
      <div>{{ this.currencyAmount[0] }}/{{ this.currencyAmount[1] }}.<a
          href="http://play.zedgames.mobi/terms-conditions"> T & C's Apply.</a></div>
    </div>
    <loading
        :show="showLoading"
        :label="loadingLabel">
    </loading>
  </div>
</template>
<script>
import {environmentConfig} from "@/config/environmentConfig";
import loading from "vue-full-loading";
import {mapMutations, mapState} from "vuex";
import ZambiaIntegrationService from "@/services/zambiaIntegrationService";

export default {
  name: "OnWifiUser",
  data() {
    return {
      msisdn: undefined,
      msisdnSubmitted: false,
      validMsisdn: true,
      showLoading: false,
      loadingLabel: "Subscribing...",
      errorMessage: false,
      subscribeError: false,
      isCampaign: false,
      marketingCurrency: ['K1', 'Daily']
    };
  },
  beforeMount() {
    this.msisdn = this.$route.query.msisdn;
    const campaignId = this.$route.query.campaignId;
    const trackerId = this.$route.query.trackerId;
    const publisherId = this.$route.query.publisherId;
    this.setCampaignId(campaignId);
    this.setTrackerId(trackerId);
    this.setPublisher(publisherId);

    if (this.campaignId) {
      this.isCampaign = true;
      this.setCurrencyAmount(this.marketingCurrency);
    }
    // console.log(`campaignId: ${this.campaignId} currencyAmount: ${this.currencyAmount} campaignPage:${this.isCampaign}`);
  },
  components: {
    loading
  },
  computed: {
    ...mapState(["showWinDailyBanner", "currencyAmount", "campaignId", "trackerId", "publisherId"])
  },
  methods: {
    ...mapMutations(["setShowWinDailyBanner", "setCampaignId", "setCurrencyAmount", "setTrackerId", "setPublisher"]),
    msisdnConversion() {
      if (this.msisdn.startsWith("0")) {
        this.msisdn = this.msisdn.slice(1);
        const zmbNumber = "260";
        this.msisdn = parseInt(zmbNumber + this.msisdn, 10);
      } else if (this.msisdn.startsWith("+")) {
        this.msisdn = this.msisdn.slice(1);
      }
    },
    async onMsisdnSubmitClicked() {
      this.toggleLoadingAnimation(true);
      if (this.msisdn.toString().length === 12) {
        const getUserResponse = await ZambiaIntegrationService.getUserViaMsisdn(this.msisdn);
        if (getUserResponse?.data?.Status === "SUBSCRIBED") {
          this.toggleLoadingAnimation();
          window.open(`${environmentConfig.zedGamesHost}/?msisdn=${this.msisdn}`, "_self");
        } else {
          const subscribeResponse = await ZambiaIntegrationService.subscribe(this.msisdn, this.currencyAmount[1], this.campaignId, this?.trackerId, this?.publisherId);
          this.msisdnSubmitted = true;
          if (!subscribeResponse?.data?.isSuccess) {
            this.toggleLoadingAnimation(false);
            this.subscribeError = true;
          } else {
            this.toggleLoadingAnimation(false);
            this.setShowWinDailyBanner(false);
            window.open(`${environmentConfig.zedGamesHost}/?msisdn=${this.msisdn}`, "_self");
          }
        }
      } else {
        this.toggleLoadingAnimation(false);
        this.validMsisdn = false;
      }
    },
    toggleLoadingAnimation(toggle = false) {
      this.showLoading = toggle;
    },
    async onRetryClicked() {
      this.resetScreensForRetry()
      await this.checkUserStatusUpdate();
    },
    async checkUserStatusUpdate() {
      const getUserResponse = await ZambiaIntegrationService.getUserViaMsisdn(this.msisdn.toString());
      if (getUserResponse?.data?.Status === "SUBSCRIBED") {
        window.open(`${environmentConfig.zedGamesHost}/?msisdn=${this.msisdn}`, "_self");
      } else {
        this.subscribeError = true;
      }
    },
    resetScreensForRetry() {
      this.msisdnSubmitted = false;
      this.subscribeError = false;
      this.errorMessage = false;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.error-message {
  color: #CE0000;
}

.error-message-text {
  color: red;
}

.terms-and-conditions {
  font-family: 'MTNBrighterSans', sans-serif;
  font-weight: normal;
  font-size: 12px;
}
</style>
